import React from 'react';
import './App.css';
import PokePicker from './components/PokePicker';




function App() {
  return (
    <div className="App">
      <PokePicker />
    </div>
  );
}

export default App;
